import { render } from "./zhengcInfo.vue?vue&type=template&id=20657f9f&scoped=true"
import script from "./zhengcInfo.vue?vue&type=script&lang=js"
export * from "./zhengcInfo.vue?vue&type=script&lang=js"

import "./zhengcInfo.vue?vue&type=style&index=0&id=20657f9f&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20657f9f"]])

export default __exports__